import { default as _91linkId_93gDrLywZeQQMeta } from "/vercel/path0/pages/affiliate/[linkId].vue?macro=true";
import { default as solutionYDgqymptRdMeta } from "/vercel/path0/pages/b2b/solution.vue?macro=true";
import { default as _91eventId_93XsWvwZy5wNMeta } from "/vercel/path0/pages/benefit/[eventId].vue?macro=true";
import { default as indexptQoaLF2yTMeta } from "/vercel/path0/pages/benefit/index.vue?macro=true";
import { default as GrabdRiJq921KYMeta } from "/vercel/path0/pages/benefit/partner/Grab.vue?macro=true";
import { default as contact_45channeln594U8pa74Meta } from "/vercel/path0/pages/board/contact-channel.vue?macro=true";
import { default as email5v2OTHM92XMeta } from "/vercel/path0/pages/board/email.vue?macro=true";
import { default as _91eventId_93P3qWoo990uMeta } from "/vercel/path0/pages/board/event/[eventId].vue?macro=true";
import { default as _91faqId_93e34zBtO18nMeta } from "/vercel/path0/pages/board/faq/[faqId].vue?macro=true";
import { default as index44bzBRzyOfMeta } from "/vercel/path0/pages/board/faq/index.vue?macro=true";
import { default as _91noticeId_93Gs8u7eNPFpMeta } from "/vercel/path0/pages/board/notice/[noticeId].vue?macro=true";
import { default as indextbyWiW6TkeMeta } from "/vercel/path0/pages/board/notice/index.vue?macro=true";
import { default as index9WKISWrDvJMeta } from "/vercel/path0/pages/buy-in-bulk/index.vue?macro=true";
import { default as esim_45use_45devicefnCPtB6phmMeta } from "/vercel/path0/pages/contents/esim-use-device.vue?macro=true";
import { default as usim_45rocket_45deliverye57oHTZE66Meta } from "/vercel/path0/pages/contents/usim-rocket-delivery.vue?macro=true";
import { default as usimsa_45careLfblwUnpZDMeta } from "/vercel/path0/pages/contents/usimsa-care.vue?macro=true";
import { default as usimsa_45quality_45guaranteeDpTrRgzhdfMeta } from "/vercel/path0/pages/contents/usimsa-quality-guarantee.vue?macro=true";
import { default as entranceXCRDogWM5MMeta } from "/vercel/path0/pages/entrance.vue?macro=true";
import { default as _91orderId_93Z8XidVj2KMMeta } from "/vercel/path0/pages/gift/checkIn/[orderId].vue?macro=true";
import { default as _91planId_93C1SVdlKExzMeta } from "/vercel/path0/pages/gift/order/[planId].vue?macro=true";
import { default as gsma0nRoMbzo3yMeta } from "/vercel/path0/pages/gsma.vue?macro=true";
import { default as domestic641WUPh8ihMeta } from "/vercel/path0/pages/guide/domestic.vue?macro=true";
import { default as enroll_45completezZl9xUEniYMeta } from "/vercel/path0/pages/guide/enroll-complete.vue?macro=true";
import { default as enrollw9LCd0IsAxMeta } from "/vercel/path0/pages/guide/enroll.vue?macro=true";
import { default as imageZoFfCm1TWGMeta } from "/vercel/path0/pages/guide/image.vue?macro=true";
import { default as indexMfxqfHtaOPMeta } from "/vercel/path0/pages/guide/index.vue?macro=true";
import { default as localszhmRy4QATMeta } from "/vercel/path0/pages/guide/local.vue?macro=true";
import { default as useXxDWIA2yS9Meta } from "/vercel/path0/pages/guide/use.vue?macro=true";
import { default as indexe9Brt5DfdhMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as fail0rpSkuHwPnMeta } from "/vercel/path0/pages/insurance/purchase/callback/fail.vue?macro=true";
import { default as successlywtM9CmuwMeta } from "/vercel/path0/pages/insurance/purchase/callback/success.vue?macro=true";
import { default as indexAVa2dCS00pMeta } from "/vercel/path0/pages/insurance/purchase/index.vue?macro=true";
import { default as _91iccid_93_45_91orderId_93bKhCroap6uMeta } from "/vercel/path0/pages/inventory/[iccid]-[orderId].vue?macro=true";
import { default as guide0ZtHqvIoTRMeta } from "/vercel/path0/pages/inventory/[orderId]/install/guide.vue?macro=true";
import { default as indexhFtW9059ZWMeta } from "/vercel/path0/pages/inventory/[orderId]/install/index.vue?macro=true";
import { default as _91planId_93pnyteSE0smMeta } from "/vercel/path0/pages/inventory/apn-guide/[planId].vue?macro=true";
import { default as checkIn_45success_45_91productType_93W4uO7ESlTuMeta } from "/vercel/path0/pages/inventory/checkIn-success-[productType].vue?macro=true";
import { default as indexuUXV1GBWS4Meta } from "/vercel/path0/pages/inventory/enroll/index.vue?macro=true";
import { default as indexhLnRyrGHStMeta } from "/vercel/path0/pages/inventory/index.vue?macro=true";
import { default as indexFNhsUZOYfgMeta } from "/vercel/path0/pages/invite/index.vue?macro=true";
import { default as receiveyc1AcR8mOhMeta } from "/vercel/path0/pages/invite/receive.vue?macro=true";
import { default as moment_45entryF9JkljaOSTMeta } from "/vercel/path0/pages/moment-entry.vue?macro=true";
import { default as indexc8KQF5U5F4Meta } from "/vercel/path0/pages/notifications/index.vue?macro=true";
import { default as _91simType_93Dca97H4VMQMeta } from "/vercel/path0/pages/order/[optionId]/[simType].vue?macro=true";
import { default as indexti0LQujv9cMeta } from "/vercel/path0/pages/order/addon/index.vue?macro=true";
import { default as fail76thCWKKSaMeta } from "/vercel/path0/pages/order/callback/fail.vue?macro=true";
import { default as indexemooIX6BKsMeta } from "/vercel/path0/pages/order/callback/npay/index.vue?macro=true";
import { default as successuDWYMhlygQMeta } from "/vercel/path0/pages/order/callback/success.vue?macro=true";
import { default as _91optionId_93aMeV7x4NcpMeta } from "/vercel/path0/pages/order/extend/[optionId].vue?macro=true";
import { default as addonG61fF1uVSeMeta } from "/vercel/path0/pages/order/success/addon.vue?macro=true";
import { default as esimwHv1DV3zIJMeta } from "/vercel/path0/pages/order/success/esim.vue?macro=true";
import { default as extendDc6MdPrYw3Meta } from "/vercel/path0/pages/order/success/extend.vue?macro=true";
import { default as guestwkiKqqsaLUMeta } from "/vercel/path0/pages/order/success/guest.vue?macro=true";
import { default as usimrQPP4CjEhzMeta } from "/vercel/path0/pages/order/success/usim.vue?macro=true";
import { default as _91eventId_93BNViPCnRlZMeta } from "/vercel/path0/pages/partners/[partner]/benefit/[eventId].vue?macro=true";
import { default as contact_45channelPd2nnf6ts5Meta } from "/vercel/path0/pages/partners/[partner]/board/contact-channel.vue?macro=true";
import { default as email00Org0Uh17Meta } from "/vercel/path0/pages/partners/[partner]/board/email.vue?macro=true";
import { default as _91faqId_93D6ERfijAdWMeta } from "/vercel/path0/pages/partners/[partner]/board/faq/[faqId].vue?macro=true";
import { default as indexFiXDquZkMBMeta } from "/vercel/path0/pages/partners/[partner]/board/faq/index.vue?macro=true";
import { default as _91noticeId_93NOgY7pLjRKMeta } from "/vercel/path0/pages/partners/[partner]/board/notice/[noticeId].vue?macro=true";
import { default as indexW1w2MeZn2NMeta } from "/vercel/path0/pages/partners/[partner]/board/notice/index.vue?macro=true";
import { default as domesticY4ciWlQnwnMeta } from "/vercel/path0/pages/partners/[partner]/guide/domestic.vue?macro=true";
import { default as enroll_45completeOiBBGEwJRrMeta } from "/vercel/path0/pages/partners/[partner]/guide/enroll-complete.vue?macro=true";
import { default as enrollgP1usaXQSfMeta } from "/vercel/path0/pages/partners/[partner]/guide/enroll.vue?macro=true";
import { default as imageKaIqqRVRGGMeta } from "/vercel/path0/pages/partners/[partner]/guide/image.vue?macro=true";
import { default as indexEjtJCzYg9PMeta } from "/vercel/path0/pages/partners/[partner]/guide/index.vue?macro=true";
import { default as localYsSXsooRsHMeta } from "/vercel/path0/pages/partners/[partner]/guide/local.vue?macro=true";
import { default as useOPeP87rGraMeta } from "/vercel/path0/pages/partners/[partner]/guide/use.vue?macro=true";
import { default as indexyOZCE2XVOHMeta } from "/vercel/path0/pages/partners/[partner]/index.vue?macro=true";
import { default as _91iccid_93_45_91orderId_93y6iak2tof4Meta } from "/vercel/path0/pages/partners/[partner]/inventory/[iccid]-[orderId].vue?macro=true";
import { default as guidephAsZioEw0Meta } from "/vercel/path0/pages/partners/[partner]/inventory/[orderId]/install/guide.vue?macro=true";
import { default as indexa89x1EoDg4Meta } from "/vercel/path0/pages/partners/[partner]/inventory/[orderId]/install/index.vue?macro=true";
import { default as _91planId_936HG9XEfmuCMeta } from "/vercel/path0/pages/partners/[partner]/inventory/apn-guide/[planId].vue?macro=true";
import { default as indexAeijLUIzDmMeta } from "/vercel/path0/pages/partners/[partner]/inventory/index.vue?macro=true";
import { default as _91simType_93lUCzttmW1YMeta } from "/vercel/path0/pages/partners/[partner]/order/[optionId]/[simType].vue?macro=true";
import { default as indexaGOEwpt5y7Meta } from "/vercel/path0/pages/partners/[partner]/order/addon/index.vue?macro=true";
import { default as failcyuFfrNNt5Meta } from "/vercel/path0/pages/partners/[partner]/order/callback/fail.vue?macro=true";
import { default as indexKW7WHwvCllMeta } from "/vercel/path0/pages/partners/[partner]/order/callback/npay/index.vue?macro=true";
import { default as successEhH0G5emG0Meta } from "/vercel/path0/pages/partners/[partner]/order/callback/success.vue?macro=true";
import { default as indexgA6LYu4fTsMeta } from "/vercel/path0/pages/partners/[partner]/order/extend/[optionId]/index.vue?macro=true";
import { default as addonJGX8c1ipkjMeta } from "/vercel/path0/pages/partners/[partner]/order/success/addon.vue?macro=true";
import { default as esim0VUTJk718gMeta } from "/vercel/path0/pages/partners/[partner]/order/success/esim.vue?macro=true";
import { default as extend5vz9qwJ1tCMeta } from "/vercel/path0/pages/partners/[partner]/order/success/extend.vue?macro=true";
import { default as guesttXAn9XzQLSMeta } from "/vercel/path0/pages/partners/[partner]/order/success/guest.vue?macro=true";
import { default as usimdAEIygyi4cMeta } from "/vercel/path0/pages/partners/[partner]/order/success/usim.vue?macro=true";
import { default as _91simType_93cVnW6Y8p6hMeta } from "/vercel/path0/pages/partners/[partner]/purchase/[planId]=[channelId]/[simType].vue?macro=true";
import { default as app_45information2FCIyaaK42Meta } from "/vercel/path0/pages/partners/[partner]/settings/app-information.vue?macro=true";
import { default as indexNd1WnfFJPkMeta } from "/vercel/path0/pages/partners/[partner]/settings/index.vue?macro=true";
import { default as change_45passwordTqTD409pqZMeta } from "/vercel/path0/pages/partners/[partner]/user/account/change-password.vue?macro=true";
import { default as delete_45successnIbBuDsaAGMeta } from "/vercel/path0/pages/partners/[partner]/user/account/delete-success.vue?macro=true";
import { default as deleteR2z3pJTcZxMeta } from "/vercel/path0/pages/partners/[partner]/user/account/delete.vue?macro=true";
import { default as indexAYXVGoXEvMMeta } from "/vercel/path0/pages/partners/[partner]/user/account/index.vue?macro=true";
import { default as consentjLmangpzMpMeta } from "/vercel/path0/pages/partners/[partner]/user/alarm/consent.vue?macro=true";
import { default as info_45benefitPLZnwCaSFdMeta } from "/vercel/path0/pages/partners/[partner]/user/alarm/info-benefit.vue?macro=true";
import { default as indexYlS00Pl1ZoMeta } from "/vercel/path0/pages/partners/[partner]/user/coupons/index.vue?macro=true";
import { default as _91orderId_93kdPeD7bI1AMeta } from "/vercel/path0/pages/partners/[partner]/user/history/[orderId].vue?macro=true";
import { default as indexWujfLO7iK2Meta } from "/vercel/path0/pages/partners/[partner]/user/history/index.vue?macro=true";
import { default as indexeTkmJYEOVJMeta } from "/vercel/path0/pages/partners/[partner]/user/index.vue?macro=true";
import { default as find_45user_45infoceT6Pt3vvOMeta } from "/vercel/path0/pages/partners/[partner]/user/login/find-user-info.vue?macro=true";
import { default as index3NRpIvW4fJMeta } from "/vercel/path0/pages/partners/[partner]/user/login/index.vue?macro=true";
import { default as simple_45signupiPxwYa2V1JMeta } from "/vercel/path0/pages/partners/[partner]/user/login/simple-signup.vue?macro=true";
import { default as successvsKCHt4fehMeta } from "/vercel/path0/pages/partners/[partner]/user/login/success.vue?macro=true";
import { default as usimsa_45signupdQYJOWbV6OMeta } from "/vercel/path0/pages/partners/[partner]/user/login/usimsa-signup.vue?macro=true";
import { default as usimsaATeVXUmhHOMeta } from "/vercel/path0/pages/partners/[partner]/user/login/usimsa.vue?macro=true";
import { default as indexIXOCSVFf6VMeta } from "/vercel/path0/pages/partners/[partner]/user/mileage/index.vue?macro=true";
import { default as _91subOrderId_93CDLB1SEEoGMeta } from "/vercel/path0/pages/partners/[partner]/user/refund/[subOrderId].vue?macro=true";
import { default as refund_45successvfxZIbaSxDMeta } from "/vercel/path0/pages/partners/[partner]/user/refund/refund-success.vue?macro=true";
import { default as indexAD6B6UTeGoMeta } from "/vercel/path0/pages/partners/[partner]/user/simple-signup/index.vue?macro=true";
import { default as moreDEXHDjEGXtMeta } from "/vercel/path0/pages/product/more.vue?macro=true";
import { default as redirect_45to_45storevk9oDvjvNAMeta } from "/vercel/path0/pages/redirect-to-store.vue?macro=true";
import { default as indexmyTA402mXcMeta } from "/vercel/path0/pages/reviews/index.vue?macro=true";
import { default as searchBIFC2dE21WMeta } from "/vercel/path0/pages/search.vue?macro=true";
import { default as sentry_45example_45pageQDS8XtWeNGMeta } from "/vercel/path0/pages/sentry-example-page.vue?macro=true";
import { default as app_45informationGLuFWzEXEYMeta } from "/vercel/path0/pages/settings/app-information.vue?macro=true";
import { default as indexKIRFIU1ID4Meta } from "/vercel/path0/pages/settings/index.vue?macro=true";
import { default as _91orderNo_93aqG0dZb0B7Meta } from "/vercel/path0/pages/shuttle/purchase/[orderNo].vue?macro=true";
import { default as fail3T4HYp0EzeMeta } from "/vercel/path0/pages/shuttle/purchase/callback/fail.vue?macro=true";
import { default as successf8eu6XJJbAMeta } from "/vercel/path0/pages/shuttle/purchase/callback/success.vue?macro=true";
import { default as private_45policylPmxoUBHLxMeta } from "/vercel/path0/pages/terms/private-policy.vue?macro=true";
import { default as usimsa_45termsy6BXW9Bz6aMeta } from "/vercel/path0/pages/terms/usimsa-terms.vue?macro=true";
import { default as change_45passwordQPjQH4uwYNMeta } from "/vercel/path0/pages/user/account/change-password.vue?macro=true";
import { default as delete_45successf5cQD1elzlMeta } from "/vercel/path0/pages/user/account/delete-success.vue?macro=true";
import { default as deleteyJ9ZFzPBkdMeta } from "/vercel/path0/pages/user/account/delete.vue?macro=true";
import { default as indexVBBUPJP8ffMeta } from "/vercel/path0/pages/user/account/index.vue?macro=true";
import { default as consentKzqNDszYT4Meta } from "/vercel/path0/pages/user/alarm/consent.vue?macro=true";
import { default as info_45benefitphrE84NjpuMeta } from "/vercel/path0/pages/user/alarm/info-benefit.vue?macro=true";
import { default as kakao_45synclOvMwZh6cnMeta } from "/vercel/path0/pages/user/callback/kakao-sync.vue?macro=true";
import { default as naverH941eAa88kMeta } from "/vercel/path0/pages/user/callback/naver.vue?macro=true";
import { default as indextAmtLGY41jMeta } from "/vercel/path0/pages/user/callback/supabase/index.vue?macro=true";
import { default as index9V7dRRx2VQMeta } from "/vercel/path0/pages/user/coupons/index.vue?macro=true";
import { default as _91simHistoty_93GZQcHYGF27Meta } from "/vercel/path0/pages/user/history/[orderId]/[simHistoty].vue?macro=true";
import { default as indexHq82ZarqOUMeta } from "/vercel/path0/pages/user/history/[orderId]/index.vue?macro=true";
import { default as _91reservationId_93CBtqPpG9WkMeta } from "/vercel/path0/pages/user/history/airport-taxi/[reservationId].vue?macro=true";
import { default as indexoAocH1WjjYMeta } from "/vercel/path0/pages/user/history/index.vue?macro=true";
import { default as _91orderGroupId_93vyapEgczByMeta } from "/vercel/path0/pages/user/history/insurance/[orderGroupId].vue?macro=true";
import { default as indexk3QLtbGbUrMeta } from "/vercel/path0/pages/user/index.vue?macro=true";
import { default as find_45user_45infoaYhs5lmiPPMeta } from "/vercel/path0/pages/user/login/find-user-info.vue?macro=true";
import { default as indexZWq46ELcfoMeta } from "/vercel/path0/pages/user/login/index.vue?macro=true";
import { default as kakao_45simple_45signupt5z4y5sIwVMeta } from "/vercel/path0/pages/user/login/kakao-simple-signup.vue?macro=true";
import { default as simple_45signuppVPLqIuKufMeta } from "/vercel/path0/pages/user/login/simple-signup.vue?macro=true";
import { default as success7OC8zQ99kEMeta } from "/vercel/path0/pages/user/login/success.vue?macro=true";
import { default as usimsa_45signupcEPUhVXDUQMeta } from "/vercel/path0/pages/user/login/usimsa-signup.vue?macro=true";
import { default as usimsaY7PbX77kjsMeta } from "/vercel/path0/pages/user/login/usimsa.vue?macro=true";
import { default as indexcXmhLidBEOMeta } from "/vercel/path0/pages/user/mileage/index.vue?macro=true";
import { default as indexzppybscFOgMeta } from "/vercel/path0/pages/user/point/index.vue?macro=true";
import { default as _91subOrderId_93lKFKpApAL4Meta } from "/vercel/path0/pages/user/refund/[subOrderId].vue?macro=true";
import { default as _91reservationId_93PAl23cAdhuMeta } from "/vercel/path0/pages/user/refund/airport-taxi/[reservationId].vue?macro=true";
import { default as _91orderGroupId_938LqsLmXlVtMeta } from "/vercel/path0/pages/user/refund/insurance/[orderGroupId].vue?macro=true";
import { default as refund_45successu3KdOqZHhDMeta } from "/vercel/path0/pages/user/refund/refund-success.vue?macro=true";
import { default as _91reviewId_93M9FsUnazazMeta } from "/vercel/path0/pages/user/review/edit/[reviewId].vue?macro=true";
import { default as indexv0vbTSvlZUMeta } from "/vercel/path0/pages/user/review/index.vue?macro=true";
import { default as successPWklmd2oAoMeta } from "/vercel/path0/pages/user/review/success.vue?macro=true";
import { default as _91reviewId_93X2M1bwIkwnMeta } from "/vercel/path0/pages/user/review/write/[reviewId].vue?macro=true";
import { default as verify_45noticew6e2RMf9tdMeta } from "/vercel/path0/pages/verify-notice.vue?macro=true";
import { default as indexL6n4ehuQzmMeta } from "/vercel/path0/pages/voucher/[orderId]/index.vue?macro=true";
export default [
  {
    name: _91linkId_93gDrLywZeQQMeta?.name ?? "affiliate-linkId",
    path: _91linkId_93gDrLywZeQQMeta?.path ?? "/affiliate/:linkId()",
    meta: _91linkId_93gDrLywZeQQMeta || {},
    alias: _91linkId_93gDrLywZeQQMeta?.alias || [],
    redirect: _91linkId_93gDrLywZeQQMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/affiliate/[linkId].vue").then(m => m.default || m)
  },
  {
    name: solutionYDgqymptRdMeta?.name ?? "b2b-solution",
    path: solutionYDgqymptRdMeta?.path ?? "/b2b/solution",
    meta: solutionYDgqymptRdMeta || {},
    alias: solutionYDgqymptRdMeta?.alias || [],
    redirect: solutionYDgqymptRdMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/b2b/solution.vue").then(m => m.default || m)
  },
  {
    name: _91eventId_93XsWvwZy5wNMeta?.name ?? "benefit-eventId",
    path: _91eventId_93XsWvwZy5wNMeta?.path ?? "/benefit/:eventId()",
    meta: _91eventId_93XsWvwZy5wNMeta || {},
    alias: _91eventId_93XsWvwZy5wNMeta?.alias || [],
    redirect: _91eventId_93XsWvwZy5wNMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/benefit/[eventId].vue").then(m => m.default || m)
  },
  {
    name: indexptQoaLF2yTMeta?.name ?? "benefit",
    path: indexptQoaLF2yTMeta?.path ?? "/benefit",
    meta: indexptQoaLF2yTMeta || {},
    alias: indexptQoaLF2yTMeta?.alias || [],
    redirect: indexptQoaLF2yTMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/benefit/index.vue").then(m => m.default || m)
  },
  {
    name: GrabdRiJq921KYMeta?.name ?? "benefit-partner-Grab",
    path: GrabdRiJq921KYMeta?.path ?? "/benefit/partner/Grab",
    meta: GrabdRiJq921KYMeta || {},
    alias: GrabdRiJq921KYMeta?.alias || [],
    redirect: GrabdRiJq921KYMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/benefit/partner/Grab.vue").then(m => m.default || m)
  },
  {
    name: contact_45channeln594U8pa74Meta?.name ?? "board-contact-channel",
    path: contact_45channeln594U8pa74Meta?.path ?? "/board/contact-channel",
    meta: contact_45channeln594U8pa74Meta || {},
    alias: contact_45channeln594U8pa74Meta?.alias || [],
    redirect: contact_45channeln594U8pa74Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/board/contact-channel.vue").then(m => m.default || m)
  },
  {
    name: email5v2OTHM92XMeta?.name ?? "board-email",
    path: email5v2OTHM92XMeta?.path ?? "/board/email",
    meta: email5v2OTHM92XMeta || {},
    alias: email5v2OTHM92XMeta?.alias || [],
    redirect: email5v2OTHM92XMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/board/email.vue").then(m => m.default || m)
  },
  {
    name: _91eventId_93P3qWoo990uMeta?.name ?? "board-event-eventId",
    path: _91eventId_93P3qWoo990uMeta?.path ?? "/board/event/:eventId()",
    meta: _91eventId_93P3qWoo990uMeta || {},
    alias: _91eventId_93P3qWoo990uMeta?.alias || [],
    redirect: _91eventId_93P3qWoo990uMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/board/event/[eventId].vue").then(m => m.default || m)
  },
  {
    name: _91faqId_93e34zBtO18nMeta?.name ?? "board-faq-faqId",
    path: _91faqId_93e34zBtO18nMeta?.path ?? "/board/faq/:faqId()",
    meta: _91faqId_93e34zBtO18nMeta || {},
    alias: _91faqId_93e34zBtO18nMeta?.alias || [],
    redirect: _91faqId_93e34zBtO18nMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/board/faq/[faqId].vue").then(m => m.default || m)
  },
  {
    name: index44bzBRzyOfMeta?.name ?? "board-faq",
    path: index44bzBRzyOfMeta?.path ?? "/board/faq",
    meta: index44bzBRzyOfMeta || {},
    alias: index44bzBRzyOfMeta?.alias || [],
    redirect: index44bzBRzyOfMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/board/faq/index.vue").then(m => m.default || m)
  },
  {
    name: _91noticeId_93Gs8u7eNPFpMeta?.name ?? "board-notice-noticeId",
    path: _91noticeId_93Gs8u7eNPFpMeta?.path ?? "/board/notice/:noticeId()",
    meta: _91noticeId_93Gs8u7eNPFpMeta || {},
    alias: _91noticeId_93Gs8u7eNPFpMeta?.alias || [],
    redirect: _91noticeId_93Gs8u7eNPFpMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/board/notice/[noticeId].vue").then(m => m.default || m)
  },
  {
    name: indextbyWiW6TkeMeta?.name ?? "board-notice",
    path: indextbyWiW6TkeMeta?.path ?? "/board/notice",
    meta: indextbyWiW6TkeMeta || {},
    alias: indextbyWiW6TkeMeta?.alias || [],
    redirect: indextbyWiW6TkeMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/board/notice/index.vue").then(m => m.default || m)
  },
  {
    name: index9WKISWrDvJMeta?.name ?? "buy-in-bulk",
    path: index9WKISWrDvJMeta?.path ?? "/buy-in-bulk",
    meta: index9WKISWrDvJMeta || {},
    alias: index9WKISWrDvJMeta?.alias || [],
    redirect: index9WKISWrDvJMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/buy-in-bulk/index.vue").then(m => m.default || m)
  },
  {
    name: esim_45use_45devicefnCPtB6phmMeta?.name ?? "contents-esim-use-device",
    path: esim_45use_45devicefnCPtB6phmMeta?.path ?? "/contents/esim-use-device",
    meta: esim_45use_45devicefnCPtB6phmMeta || {},
    alias: esim_45use_45devicefnCPtB6phmMeta?.alias || [],
    redirect: esim_45use_45devicefnCPtB6phmMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/contents/esim-use-device.vue").then(m => m.default || m)
  },
  {
    name: usim_45rocket_45deliverye57oHTZE66Meta?.name ?? "contents-usim-rocket-delivery",
    path: usim_45rocket_45deliverye57oHTZE66Meta?.path ?? "/contents/usim-rocket-delivery",
    meta: usim_45rocket_45deliverye57oHTZE66Meta || {},
    alias: usim_45rocket_45deliverye57oHTZE66Meta?.alias || [],
    redirect: usim_45rocket_45deliverye57oHTZE66Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/contents/usim-rocket-delivery.vue").then(m => m.default || m)
  },
  {
    name: usimsa_45careLfblwUnpZDMeta?.name ?? "contents-usimsa-care",
    path: usimsa_45careLfblwUnpZDMeta?.path ?? "/contents/usimsa-care",
    meta: usimsa_45careLfblwUnpZDMeta || {},
    alias: usimsa_45careLfblwUnpZDMeta?.alias || [],
    redirect: usimsa_45careLfblwUnpZDMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/contents/usimsa-care.vue").then(m => m.default || m)
  },
  {
    name: usimsa_45quality_45guaranteeDpTrRgzhdfMeta?.name ?? "contents-usimsa-quality-guarantee",
    path: usimsa_45quality_45guaranteeDpTrRgzhdfMeta?.path ?? "/contents/usimsa-quality-guarantee",
    meta: usimsa_45quality_45guaranteeDpTrRgzhdfMeta || {},
    alias: usimsa_45quality_45guaranteeDpTrRgzhdfMeta?.alias || [],
    redirect: usimsa_45quality_45guaranteeDpTrRgzhdfMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/contents/usimsa-quality-guarantee.vue").then(m => m.default || m)
  },
  {
    name: entranceXCRDogWM5MMeta?.name ?? "entrance",
    path: entranceXCRDogWM5MMeta?.path ?? "/entrance",
    meta: entranceXCRDogWM5MMeta || {},
    alias: entranceXCRDogWM5MMeta?.alias || [],
    redirect: entranceXCRDogWM5MMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/entrance.vue").then(m => m.default || m)
  },
  {
    name: _91orderId_93Z8XidVj2KMMeta?.name ?? "gift-checkIn-orderId",
    path: _91orderId_93Z8XidVj2KMMeta?.path ?? "/gift/checkIn/:orderId()",
    meta: _91orderId_93Z8XidVj2KMMeta || {},
    alias: _91orderId_93Z8XidVj2KMMeta?.alias || [],
    redirect: _91orderId_93Z8XidVj2KMMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/gift/checkIn/[orderId].vue").then(m => m.default || m)
  },
  {
    name: _91planId_93C1SVdlKExzMeta?.name ?? "gift-order-planId",
    path: _91planId_93C1SVdlKExzMeta?.path ?? "/gift/order/:planId()",
    meta: _91planId_93C1SVdlKExzMeta || {},
    alias: _91planId_93C1SVdlKExzMeta?.alias || [],
    redirect: _91planId_93C1SVdlKExzMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/gift/order/[planId].vue").then(m => m.default || m)
  },
  {
    name: gsma0nRoMbzo3yMeta?.name ?? "gsma",
    path: gsma0nRoMbzo3yMeta?.path ?? "/gsma",
    meta: gsma0nRoMbzo3yMeta || {},
    alias: gsma0nRoMbzo3yMeta?.alias || [],
    redirect: gsma0nRoMbzo3yMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/gsma.vue").then(m => m.default || m)
  },
  {
    name: domestic641WUPh8ihMeta?.name ?? "guide-domestic",
    path: domestic641WUPh8ihMeta?.path ?? "/guide/domestic",
    meta: domestic641WUPh8ihMeta || {},
    alias: domestic641WUPh8ihMeta?.alias || [],
    redirect: domestic641WUPh8ihMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/guide/domestic.vue").then(m => m.default || m)
  },
  {
    name: enroll_45completezZl9xUEniYMeta?.name ?? "guide-enroll-complete",
    path: enroll_45completezZl9xUEniYMeta?.path ?? "/guide/enroll-complete",
    meta: enroll_45completezZl9xUEniYMeta || {},
    alias: enroll_45completezZl9xUEniYMeta?.alias || [],
    redirect: enroll_45completezZl9xUEniYMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/guide/enroll-complete.vue").then(m => m.default || m)
  },
  {
    name: enrollw9LCd0IsAxMeta?.name ?? "guide-enroll",
    path: enrollw9LCd0IsAxMeta?.path ?? "/guide/enroll",
    meta: enrollw9LCd0IsAxMeta || {},
    alias: enrollw9LCd0IsAxMeta?.alias || [],
    redirect: enrollw9LCd0IsAxMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/guide/enroll.vue").then(m => m.default || m)
  },
  {
    name: imageZoFfCm1TWGMeta?.name ?? "guide-image",
    path: imageZoFfCm1TWGMeta?.path ?? "/guide/image",
    meta: imageZoFfCm1TWGMeta || {},
    alias: imageZoFfCm1TWGMeta?.alias || [],
    redirect: imageZoFfCm1TWGMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/guide/image.vue").then(m => m.default || m)
  },
  {
    name: indexMfxqfHtaOPMeta?.name ?? "guide",
    path: indexMfxqfHtaOPMeta?.path ?? "/guide",
    meta: indexMfxqfHtaOPMeta || {},
    alias: indexMfxqfHtaOPMeta?.alias || [],
    redirect: indexMfxqfHtaOPMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/guide/index.vue").then(m => m.default || m)
  },
  {
    name: localszhmRy4QATMeta?.name ?? "guide-local",
    path: localszhmRy4QATMeta?.path ?? "/guide/local",
    meta: localszhmRy4QATMeta || {},
    alias: localszhmRy4QATMeta?.alias || [],
    redirect: localszhmRy4QATMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/guide/local.vue").then(m => m.default || m)
  },
  {
    name: useXxDWIA2yS9Meta?.name ?? "guide-use",
    path: useXxDWIA2yS9Meta?.path ?? "/guide/use",
    meta: useXxDWIA2yS9Meta || {},
    alias: useXxDWIA2yS9Meta?.alias || [],
    redirect: useXxDWIA2yS9Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/guide/use.vue").then(m => m.default || m)
  },
  {
    name: indexe9Brt5DfdhMeta?.name ?? "index",
    path: indexe9Brt5DfdhMeta?.path ?? "/",
    meta: indexe9Brt5DfdhMeta || {},
    alias: indexe9Brt5DfdhMeta?.alias || [],
    redirect: indexe9Brt5DfdhMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/index.vue").then(m => m.default || m)
  },
  {
    name: fail0rpSkuHwPnMeta?.name ?? "insurance-purchase-callback-fail",
    path: fail0rpSkuHwPnMeta?.path ?? "/insurance/purchase/callback/fail",
    meta: fail0rpSkuHwPnMeta || {},
    alias: fail0rpSkuHwPnMeta?.alias || [],
    redirect: fail0rpSkuHwPnMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/insurance/purchase/callback/fail.vue").then(m => m.default || m)
  },
  {
    name: successlywtM9CmuwMeta?.name ?? "insurance-purchase-callback-success",
    path: successlywtM9CmuwMeta?.path ?? "/insurance/purchase/callback/success",
    meta: successlywtM9CmuwMeta || {},
    alias: successlywtM9CmuwMeta?.alias || [],
    redirect: successlywtM9CmuwMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/insurance/purchase/callback/success.vue").then(m => m.default || m)
  },
  {
    name: indexAVa2dCS00pMeta?.name ?? "insurance-purchase",
    path: indexAVa2dCS00pMeta?.path ?? "/insurance/purchase",
    meta: indexAVa2dCS00pMeta || {},
    alias: indexAVa2dCS00pMeta?.alias || [],
    redirect: indexAVa2dCS00pMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/insurance/purchase/index.vue").then(m => m.default || m)
  },
  {
    name: _91iccid_93_45_91orderId_93bKhCroap6uMeta?.name ?? "inventory-iccid-orderId",
    path: _91iccid_93_45_91orderId_93bKhCroap6uMeta?.path ?? "/inventory/:iccid()-:orderId()",
    meta: _91iccid_93_45_91orderId_93bKhCroap6uMeta || {},
    alias: _91iccid_93_45_91orderId_93bKhCroap6uMeta?.alias || [],
    redirect: _91iccid_93_45_91orderId_93bKhCroap6uMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/inventory/[iccid]-[orderId].vue").then(m => m.default || m)
  },
  {
    name: guide0ZtHqvIoTRMeta?.name ?? "inventory-orderId-install-guide",
    path: guide0ZtHqvIoTRMeta?.path ?? "/inventory/:orderId()/install/guide",
    meta: guide0ZtHqvIoTRMeta || {},
    alias: guide0ZtHqvIoTRMeta?.alias || [],
    redirect: guide0ZtHqvIoTRMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/inventory/[orderId]/install/guide.vue").then(m => m.default || m)
  },
  {
    name: indexhFtW9059ZWMeta?.name ?? "inventory-orderId-install",
    path: indexhFtW9059ZWMeta?.path ?? "/inventory/:orderId()/install",
    meta: indexhFtW9059ZWMeta || {},
    alias: indexhFtW9059ZWMeta?.alias || [],
    redirect: indexhFtW9059ZWMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/inventory/[orderId]/install/index.vue").then(m => m.default || m)
  },
  {
    name: _91planId_93pnyteSE0smMeta?.name ?? "inventory-apn-guide-planId",
    path: _91planId_93pnyteSE0smMeta?.path ?? "/inventory/apn-guide/:planId()",
    meta: _91planId_93pnyteSE0smMeta || {},
    alias: _91planId_93pnyteSE0smMeta?.alias || [],
    redirect: _91planId_93pnyteSE0smMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/inventory/apn-guide/[planId].vue").then(m => m.default || m)
  },
  {
    name: checkIn_45success_45_91productType_93W4uO7ESlTuMeta?.name ?? "inventory-checkIn-success-productType",
    path: checkIn_45success_45_91productType_93W4uO7ESlTuMeta?.path ?? "/inventory/checkIn-success-:productType()",
    meta: checkIn_45success_45_91productType_93W4uO7ESlTuMeta || {},
    alias: checkIn_45success_45_91productType_93W4uO7ESlTuMeta?.alias || [],
    redirect: checkIn_45success_45_91productType_93W4uO7ESlTuMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/inventory/checkIn-success-[productType].vue").then(m => m.default || m)
  },
  {
    name: indexuUXV1GBWS4Meta?.name ?? "inventory-enroll",
    path: indexuUXV1GBWS4Meta?.path ?? "/inventory/enroll",
    meta: indexuUXV1GBWS4Meta || {},
    alias: indexuUXV1GBWS4Meta?.alias || [],
    redirect: indexuUXV1GBWS4Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/inventory/enroll/index.vue").then(m => m.default || m)
  },
  {
    name: indexhLnRyrGHStMeta?.name ?? "inventory",
    path: indexhLnRyrGHStMeta?.path ?? "/inventory",
    meta: indexhLnRyrGHStMeta || {},
    alias: indexhLnRyrGHStMeta?.alias || [],
    redirect: indexhLnRyrGHStMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/inventory/index.vue").then(m => m.default || m)
  },
  {
    name: indexFNhsUZOYfgMeta?.name ?? "invite",
    path: indexFNhsUZOYfgMeta?.path ?? "/invite",
    meta: indexFNhsUZOYfgMeta || {},
    alias: indexFNhsUZOYfgMeta?.alias || [],
    redirect: indexFNhsUZOYfgMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/invite/index.vue").then(m => m.default || m)
  },
  {
    name: receiveyc1AcR8mOhMeta?.name ?? "invite-receive",
    path: receiveyc1AcR8mOhMeta?.path ?? "/invite/receive",
    meta: receiveyc1AcR8mOhMeta || {},
    alias: receiveyc1AcR8mOhMeta?.alias || [],
    redirect: receiveyc1AcR8mOhMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/invite/receive.vue").then(m => m.default || m)
  },
  {
    name: moment_45entryF9JkljaOSTMeta?.name ?? "moment-entry",
    path: moment_45entryF9JkljaOSTMeta?.path ?? "/moment-entry",
    meta: moment_45entryF9JkljaOSTMeta || {},
    alias: moment_45entryF9JkljaOSTMeta?.alias || [],
    redirect: moment_45entryF9JkljaOSTMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/moment-entry.vue").then(m => m.default || m)
  },
  {
    name: indexc8KQF5U5F4Meta?.name ?? "notifications",
    path: indexc8KQF5U5F4Meta?.path ?? "/notifications",
    meta: indexc8KQF5U5F4Meta || {},
    alias: indexc8KQF5U5F4Meta?.alias || [],
    redirect: indexc8KQF5U5F4Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/notifications/index.vue").then(m => m.default || m)
  },
  {
    name: _91simType_93Dca97H4VMQMeta?.name ?? "order-optionId-simType",
    path: _91simType_93Dca97H4VMQMeta?.path ?? "/order/:optionId()/:simType()",
    meta: _91simType_93Dca97H4VMQMeta || {},
    alias: _91simType_93Dca97H4VMQMeta?.alias || [],
    redirect: _91simType_93Dca97H4VMQMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/order/[optionId]/[simType].vue").then(m => m.default || m)
  },
  {
    name: indexti0LQujv9cMeta?.name ?? "order-addon",
    path: indexti0LQujv9cMeta?.path ?? "/order/addon",
    meta: indexti0LQujv9cMeta || {},
    alias: indexti0LQujv9cMeta?.alias || [],
    redirect: indexti0LQujv9cMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/order/addon/index.vue").then(m => m.default || m)
  },
  {
    name: fail76thCWKKSaMeta?.name ?? "order-callback-fail",
    path: fail76thCWKKSaMeta?.path ?? "/order/callback/fail",
    meta: fail76thCWKKSaMeta || {},
    alias: fail76thCWKKSaMeta?.alias || [],
    redirect: fail76thCWKKSaMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/order/callback/fail.vue").then(m => m.default || m)
  },
  {
    name: indexemooIX6BKsMeta?.name ?? "order-callback-npay",
    path: indexemooIX6BKsMeta?.path ?? "/order/callback/npay",
    meta: indexemooIX6BKsMeta || {},
    alias: indexemooIX6BKsMeta?.alias || [],
    redirect: indexemooIX6BKsMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/order/callback/npay/index.vue").then(m => m.default || m)
  },
  {
    name: successuDWYMhlygQMeta?.name ?? "order-callback-success",
    path: successuDWYMhlygQMeta?.path ?? "/order/callback/success",
    meta: successuDWYMhlygQMeta || {},
    alias: successuDWYMhlygQMeta?.alias || [],
    redirect: successuDWYMhlygQMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/order/callback/success.vue").then(m => m.default || m)
  },
  {
    name: _91optionId_93aMeV7x4NcpMeta?.name ?? "order-extend-optionId",
    path: _91optionId_93aMeV7x4NcpMeta?.path ?? "/order/extend/:optionId()",
    meta: _91optionId_93aMeV7x4NcpMeta || {},
    alias: _91optionId_93aMeV7x4NcpMeta?.alias || [],
    redirect: _91optionId_93aMeV7x4NcpMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/order/extend/[optionId].vue").then(m => m.default || m)
  },
  {
    name: addonG61fF1uVSeMeta?.name ?? "order-success-addon",
    path: addonG61fF1uVSeMeta?.path ?? "/order/success/addon",
    meta: addonG61fF1uVSeMeta || {},
    alias: addonG61fF1uVSeMeta?.alias || [],
    redirect: addonG61fF1uVSeMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/order/success/addon.vue").then(m => m.default || m)
  },
  {
    name: esimwHv1DV3zIJMeta?.name ?? "order-success-esim",
    path: esimwHv1DV3zIJMeta?.path ?? "/order/success/esim",
    meta: esimwHv1DV3zIJMeta || {},
    alias: esimwHv1DV3zIJMeta?.alias || [],
    redirect: esimwHv1DV3zIJMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/order/success/esim.vue").then(m => m.default || m)
  },
  {
    name: extendDc6MdPrYw3Meta?.name ?? "order-success-extend",
    path: extendDc6MdPrYw3Meta?.path ?? "/order/success/extend",
    meta: extendDc6MdPrYw3Meta || {},
    alias: extendDc6MdPrYw3Meta?.alias || [],
    redirect: extendDc6MdPrYw3Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/order/success/extend.vue").then(m => m.default || m)
  },
  {
    name: guestwkiKqqsaLUMeta?.name ?? "order-success-guest",
    path: guestwkiKqqsaLUMeta?.path ?? "/order/success/guest",
    meta: guestwkiKqqsaLUMeta || {},
    alias: guestwkiKqqsaLUMeta?.alias || [],
    redirect: guestwkiKqqsaLUMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/order/success/guest.vue").then(m => m.default || m)
  },
  {
    name: usimrQPP4CjEhzMeta?.name ?? "order-success-usim",
    path: usimrQPP4CjEhzMeta?.path ?? "/order/success/usim",
    meta: usimrQPP4CjEhzMeta || {},
    alias: usimrQPP4CjEhzMeta?.alias || [],
    redirect: usimrQPP4CjEhzMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/order/success/usim.vue").then(m => m.default || m)
  },
  {
    name: _91eventId_93BNViPCnRlZMeta?.name ?? "partners-partner-benefit-eventId",
    path: _91eventId_93BNViPCnRlZMeta?.path ?? "/partners/:partner()/benefit/:eventId()",
    meta: _91eventId_93BNViPCnRlZMeta || {},
    alias: _91eventId_93BNViPCnRlZMeta?.alias || [],
    redirect: _91eventId_93BNViPCnRlZMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/benefit/[eventId].vue").then(m => m.default || m)
  },
  {
    name: contact_45channelPd2nnf6ts5Meta?.name ?? "partners-partner-board-contact-channel",
    path: contact_45channelPd2nnf6ts5Meta?.path ?? "/partners/:partner()/board/contact-channel",
    meta: contact_45channelPd2nnf6ts5Meta || {},
    alias: contact_45channelPd2nnf6ts5Meta?.alias || [],
    redirect: contact_45channelPd2nnf6ts5Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/board/contact-channel.vue").then(m => m.default || m)
  },
  {
    name: email00Org0Uh17Meta?.name ?? "partners-partner-board-email",
    path: email00Org0Uh17Meta?.path ?? "/partners/:partner()/board/email",
    meta: email00Org0Uh17Meta || {},
    alias: email00Org0Uh17Meta?.alias || [],
    redirect: email00Org0Uh17Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/board/email.vue").then(m => m.default || m)
  },
  {
    name: _91faqId_93D6ERfijAdWMeta?.name ?? "partners-partner-board-faq-faqId",
    path: _91faqId_93D6ERfijAdWMeta?.path ?? "/partners/:partner()/board/faq/:faqId()",
    meta: _91faqId_93D6ERfijAdWMeta || {},
    alias: _91faqId_93D6ERfijAdWMeta?.alias || [],
    redirect: _91faqId_93D6ERfijAdWMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/board/faq/[faqId].vue").then(m => m.default || m)
  },
  {
    name: indexFiXDquZkMBMeta?.name ?? "partners-partner-board-faq",
    path: indexFiXDquZkMBMeta?.path ?? "/partners/:partner()/board/faq",
    meta: indexFiXDquZkMBMeta || {},
    alias: indexFiXDquZkMBMeta?.alias || [],
    redirect: indexFiXDquZkMBMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/board/faq/index.vue").then(m => m.default || m)
  },
  {
    name: _91noticeId_93NOgY7pLjRKMeta?.name ?? "partners-partner-board-notice-noticeId",
    path: _91noticeId_93NOgY7pLjRKMeta?.path ?? "/partners/:partner()/board/notice/:noticeId()",
    meta: _91noticeId_93NOgY7pLjRKMeta || {},
    alias: _91noticeId_93NOgY7pLjRKMeta?.alias || [],
    redirect: _91noticeId_93NOgY7pLjRKMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/board/notice/[noticeId].vue").then(m => m.default || m)
  },
  {
    name: indexW1w2MeZn2NMeta?.name ?? "partners-partner-board-notice",
    path: indexW1w2MeZn2NMeta?.path ?? "/partners/:partner()/board/notice",
    meta: indexW1w2MeZn2NMeta || {},
    alias: indexW1w2MeZn2NMeta?.alias || [],
    redirect: indexW1w2MeZn2NMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/board/notice/index.vue").then(m => m.default || m)
  },
  {
    name: domesticY4ciWlQnwnMeta?.name ?? "partners-partner-guide-domestic",
    path: domesticY4ciWlQnwnMeta?.path ?? "/partners/:partner()/guide/domestic",
    meta: domesticY4ciWlQnwnMeta || {},
    alias: domesticY4ciWlQnwnMeta?.alias || [],
    redirect: domesticY4ciWlQnwnMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/guide/domestic.vue").then(m => m.default || m)
  },
  {
    name: enroll_45completeOiBBGEwJRrMeta?.name ?? "partners-partner-guide-enroll-complete",
    path: enroll_45completeOiBBGEwJRrMeta?.path ?? "/partners/:partner()/guide/enroll-complete",
    meta: enroll_45completeOiBBGEwJRrMeta || {},
    alias: enroll_45completeOiBBGEwJRrMeta?.alias || [],
    redirect: enroll_45completeOiBBGEwJRrMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/guide/enroll-complete.vue").then(m => m.default || m)
  },
  {
    name: enrollgP1usaXQSfMeta?.name ?? "partners-partner-guide-enroll",
    path: enrollgP1usaXQSfMeta?.path ?? "/partners/:partner()/guide/enroll",
    meta: enrollgP1usaXQSfMeta || {},
    alias: enrollgP1usaXQSfMeta?.alias || [],
    redirect: enrollgP1usaXQSfMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/guide/enroll.vue").then(m => m.default || m)
  },
  {
    name: imageKaIqqRVRGGMeta?.name ?? "partners-partner-guide-image",
    path: imageKaIqqRVRGGMeta?.path ?? "/partners/:partner()/guide/image",
    meta: imageKaIqqRVRGGMeta || {},
    alias: imageKaIqqRVRGGMeta?.alias || [],
    redirect: imageKaIqqRVRGGMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/guide/image.vue").then(m => m.default || m)
  },
  {
    name: indexEjtJCzYg9PMeta?.name ?? "partners-partner-guide",
    path: indexEjtJCzYg9PMeta?.path ?? "/partners/:partner()/guide",
    meta: indexEjtJCzYg9PMeta || {},
    alias: indexEjtJCzYg9PMeta?.alias || [],
    redirect: indexEjtJCzYg9PMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/guide/index.vue").then(m => m.default || m)
  },
  {
    name: localYsSXsooRsHMeta?.name ?? "partners-partner-guide-local",
    path: localYsSXsooRsHMeta?.path ?? "/partners/:partner()/guide/local",
    meta: localYsSXsooRsHMeta || {},
    alias: localYsSXsooRsHMeta?.alias || [],
    redirect: localYsSXsooRsHMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/guide/local.vue").then(m => m.default || m)
  },
  {
    name: useOPeP87rGraMeta?.name ?? "partners-partner-guide-use",
    path: useOPeP87rGraMeta?.path ?? "/partners/:partner()/guide/use",
    meta: useOPeP87rGraMeta || {},
    alias: useOPeP87rGraMeta?.alias || [],
    redirect: useOPeP87rGraMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/guide/use.vue").then(m => m.default || m)
  },
  {
    name: indexyOZCE2XVOHMeta?.name ?? "partners-partner",
    path: indexyOZCE2XVOHMeta?.path ?? "/partners/:partner()",
    meta: indexyOZCE2XVOHMeta || {},
    alias: indexyOZCE2XVOHMeta?.alias || [],
    redirect: indexyOZCE2XVOHMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/index.vue").then(m => m.default || m)
  },
  {
    name: _91iccid_93_45_91orderId_93y6iak2tof4Meta?.name ?? "partners-partner-inventory-iccid-orderId",
    path: _91iccid_93_45_91orderId_93y6iak2tof4Meta?.path ?? "/partners/:partner()/inventory/:iccid()-:orderId()",
    meta: _91iccid_93_45_91orderId_93y6iak2tof4Meta || {},
    alias: _91iccid_93_45_91orderId_93y6iak2tof4Meta?.alias || [],
    redirect: _91iccid_93_45_91orderId_93y6iak2tof4Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/inventory/[iccid]-[orderId].vue").then(m => m.default || m)
  },
  {
    name: guidephAsZioEw0Meta?.name ?? "partners-partner-inventory-orderId-install-guide",
    path: guidephAsZioEw0Meta?.path ?? "/partners/:partner()/inventory/:orderId()/install/guide",
    meta: guidephAsZioEw0Meta || {},
    alias: guidephAsZioEw0Meta?.alias || [],
    redirect: guidephAsZioEw0Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/inventory/[orderId]/install/guide.vue").then(m => m.default || m)
  },
  {
    name: indexa89x1EoDg4Meta?.name ?? "partners-partner-inventory-orderId-install",
    path: indexa89x1EoDg4Meta?.path ?? "/partners/:partner()/inventory/:orderId()/install",
    meta: indexa89x1EoDg4Meta || {},
    alias: indexa89x1EoDg4Meta?.alias || [],
    redirect: indexa89x1EoDg4Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/inventory/[orderId]/install/index.vue").then(m => m.default || m)
  },
  {
    name: _91planId_936HG9XEfmuCMeta?.name ?? "partners-partner-inventory-apn-guide-planId",
    path: _91planId_936HG9XEfmuCMeta?.path ?? "/partners/:partner()/inventory/apn-guide/:planId()",
    meta: _91planId_936HG9XEfmuCMeta || {},
    alias: _91planId_936HG9XEfmuCMeta?.alias || [],
    redirect: _91planId_936HG9XEfmuCMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/inventory/apn-guide/[planId].vue").then(m => m.default || m)
  },
  {
    name: indexAeijLUIzDmMeta?.name ?? "partners-partner-inventory",
    path: indexAeijLUIzDmMeta?.path ?? "/partners/:partner()/inventory",
    meta: indexAeijLUIzDmMeta || {},
    alias: indexAeijLUIzDmMeta?.alias || [],
    redirect: indexAeijLUIzDmMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/inventory/index.vue").then(m => m.default || m)
  },
  {
    name: _91simType_93lUCzttmW1YMeta?.name ?? "partners-partner-order-optionId-simType",
    path: _91simType_93lUCzttmW1YMeta?.path ?? "/partners/:partner()/order/:optionId()/:simType()",
    meta: _91simType_93lUCzttmW1YMeta || {},
    alias: _91simType_93lUCzttmW1YMeta?.alias || [],
    redirect: _91simType_93lUCzttmW1YMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/order/[optionId]/[simType].vue").then(m => m.default || m)
  },
  {
    name: indexaGOEwpt5y7Meta?.name ?? "partners-partner-order-addon",
    path: indexaGOEwpt5y7Meta?.path ?? "/partners/:partner()/order/addon",
    meta: indexaGOEwpt5y7Meta || {},
    alias: indexaGOEwpt5y7Meta?.alias || [],
    redirect: indexaGOEwpt5y7Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/order/addon/index.vue").then(m => m.default || m)
  },
  {
    name: failcyuFfrNNt5Meta?.name ?? "partners-partner-order-callback-fail",
    path: failcyuFfrNNt5Meta?.path ?? "/partners/:partner()/order/callback/fail",
    meta: failcyuFfrNNt5Meta || {},
    alias: failcyuFfrNNt5Meta?.alias || [],
    redirect: failcyuFfrNNt5Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/order/callback/fail.vue").then(m => m.default || m)
  },
  {
    name: indexKW7WHwvCllMeta?.name ?? "partners-partner-order-callback-npay",
    path: indexKW7WHwvCllMeta?.path ?? "/partners/:partner()/order/callback/npay",
    meta: indexKW7WHwvCllMeta || {},
    alias: indexKW7WHwvCllMeta?.alias || [],
    redirect: indexKW7WHwvCllMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/order/callback/npay/index.vue").then(m => m.default || m)
  },
  {
    name: successEhH0G5emG0Meta?.name ?? "partners-partner-order-callback-success",
    path: successEhH0G5emG0Meta?.path ?? "/partners/:partner()/order/callback/success",
    meta: successEhH0G5emG0Meta || {},
    alias: successEhH0G5emG0Meta?.alias || [],
    redirect: successEhH0G5emG0Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/order/callback/success.vue").then(m => m.default || m)
  },
  {
    name: indexgA6LYu4fTsMeta?.name ?? "partners-partner-order-extend-optionId",
    path: indexgA6LYu4fTsMeta?.path ?? "/partners/:partner()/order/extend/:optionId()",
    meta: indexgA6LYu4fTsMeta || {},
    alias: indexgA6LYu4fTsMeta?.alias || [],
    redirect: indexgA6LYu4fTsMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/order/extend/[optionId]/index.vue").then(m => m.default || m)
  },
  {
    name: addonJGX8c1ipkjMeta?.name ?? "partners-partner-order-success-addon",
    path: addonJGX8c1ipkjMeta?.path ?? "/partners/:partner()/order/success/addon",
    meta: addonJGX8c1ipkjMeta || {},
    alias: addonJGX8c1ipkjMeta?.alias || [],
    redirect: addonJGX8c1ipkjMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/order/success/addon.vue").then(m => m.default || m)
  },
  {
    name: esim0VUTJk718gMeta?.name ?? "partners-partner-order-success-esim",
    path: esim0VUTJk718gMeta?.path ?? "/partners/:partner()/order/success/esim",
    meta: esim0VUTJk718gMeta || {},
    alias: esim0VUTJk718gMeta?.alias || [],
    redirect: esim0VUTJk718gMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/order/success/esim.vue").then(m => m.default || m)
  },
  {
    name: extend5vz9qwJ1tCMeta?.name ?? "partners-partner-order-success-extend",
    path: extend5vz9qwJ1tCMeta?.path ?? "/partners/:partner()/order/success/extend",
    meta: extend5vz9qwJ1tCMeta || {},
    alias: extend5vz9qwJ1tCMeta?.alias || [],
    redirect: extend5vz9qwJ1tCMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/order/success/extend.vue").then(m => m.default || m)
  },
  {
    name: guesttXAn9XzQLSMeta?.name ?? "partners-partner-order-success-guest",
    path: guesttXAn9XzQLSMeta?.path ?? "/partners/:partner()/order/success/guest",
    meta: guesttXAn9XzQLSMeta || {},
    alias: guesttXAn9XzQLSMeta?.alias || [],
    redirect: guesttXAn9XzQLSMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/order/success/guest.vue").then(m => m.default || m)
  },
  {
    name: usimdAEIygyi4cMeta?.name ?? "partners-partner-order-success-usim",
    path: usimdAEIygyi4cMeta?.path ?? "/partners/:partner()/order/success/usim",
    meta: usimdAEIygyi4cMeta || {},
    alias: usimdAEIygyi4cMeta?.alias || [],
    redirect: usimdAEIygyi4cMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/order/success/usim.vue").then(m => m.default || m)
  },
  {
    name: _91simType_93cVnW6Y8p6hMeta?.name ?? "partners-partner-purchase-planId=channelId-simType",
    path: _91simType_93cVnW6Y8p6hMeta?.path ?? "/partners/:partner()/purchase/:planId()=:channelId()/:simType()",
    meta: _91simType_93cVnW6Y8p6hMeta || {},
    alias: _91simType_93cVnW6Y8p6hMeta?.alias || [],
    redirect: _91simType_93cVnW6Y8p6hMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/purchase/[planId]=[channelId]/[simType].vue").then(m => m.default || m)
  },
  {
    name: app_45information2FCIyaaK42Meta?.name ?? "partners-partner-settings-app-information",
    path: app_45information2FCIyaaK42Meta?.path ?? "/partners/:partner()/settings/app-information",
    meta: app_45information2FCIyaaK42Meta || {},
    alias: app_45information2FCIyaaK42Meta?.alias || [],
    redirect: app_45information2FCIyaaK42Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/settings/app-information.vue").then(m => m.default || m)
  },
  {
    name: indexNd1WnfFJPkMeta?.name ?? "partners-partner-settings",
    path: indexNd1WnfFJPkMeta?.path ?? "/partners/:partner()/settings",
    meta: indexNd1WnfFJPkMeta || {},
    alias: indexNd1WnfFJPkMeta?.alias || [],
    redirect: indexNd1WnfFJPkMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/settings/index.vue").then(m => m.default || m)
  },
  {
    name: change_45passwordTqTD409pqZMeta?.name ?? "partners-partner-user-account-change-password",
    path: change_45passwordTqTD409pqZMeta?.path ?? "/partners/:partner()/user/account/change-password",
    meta: change_45passwordTqTD409pqZMeta || {},
    alias: change_45passwordTqTD409pqZMeta?.alias || [],
    redirect: change_45passwordTqTD409pqZMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/user/account/change-password.vue").then(m => m.default || m)
  },
  {
    name: delete_45successnIbBuDsaAGMeta?.name ?? "partners-partner-user-account-delete-success",
    path: delete_45successnIbBuDsaAGMeta?.path ?? "/partners/:partner()/user/account/delete-success",
    meta: delete_45successnIbBuDsaAGMeta || {},
    alias: delete_45successnIbBuDsaAGMeta?.alias || [],
    redirect: delete_45successnIbBuDsaAGMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/user/account/delete-success.vue").then(m => m.default || m)
  },
  {
    name: deleteR2z3pJTcZxMeta?.name ?? "partners-partner-user-account-delete",
    path: deleteR2z3pJTcZxMeta?.path ?? "/partners/:partner()/user/account/delete",
    meta: deleteR2z3pJTcZxMeta || {},
    alias: deleteR2z3pJTcZxMeta?.alias || [],
    redirect: deleteR2z3pJTcZxMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/user/account/delete.vue").then(m => m.default || m)
  },
  {
    name: indexAYXVGoXEvMMeta?.name ?? "partners-partner-user-account",
    path: indexAYXVGoXEvMMeta?.path ?? "/partners/:partner()/user/account",
    meta: indexAYXVGoXEvMMeta || {},
    alias: indexAYXVGoXEvMMeta?.alias || [],
    redirect: indexAYXVGoXEvMMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/user/account/index.vue").then(m => m.default || m)
  },
  {
    name: consentjLmangpzMpMeta?.name ?? "partners-partner-user-alarm-consent",
    path: consentjLmangpzMpMeta?.path ?? "/partners/:partner()/user/alarm/consent",
    meta: consentjLmangpzMpMeta || {},
    alias: consentjLmangpzMpMeta?.alias || [],
    redirect: consentjLmangpzMpMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/user/alarm/consent.vue").then(m => m.default || m)
  },
  {
    name: info_45benefitPLZnwCaSFdMeta?.name ?? "partners-partner-user-alarm-info-benefit",
    path: info_45benefitPLZnwCaSFdMeta?.path ?? "/partners/:partner()/user/alarm/info-benefit",
    meta: info_45benefitPLZnwCaSFdMeta || {},
    alias: info_45benefitPLZnwCaSFdMeta?.alias || [],
    redirect: info_45benefitPLZnwCaSFdMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/user/alarm/info-benefit.vue").then(m => m.default || m)
  },
  {
    name: indexYlS00Pl1ZoMeta?.name ?? "partners-partner-user-coupons",
    path: indexYlS00Pl1ZoMeta?.path ?? "/partners/:partner()/user/coupons",
    meta: indexYlS00Pl1ZoMeta || {},
    alias: indexYlS00Pl1ZoMeta?.alias || [],
    redirect: indexYlS00Pl1ZoMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/user/coupons/index.vue").then(m => m.default || m)
  },
  {
    name: _91orderId_93kdPeD7bI1AMeta?.name ?? "partners-partner-user-history-orderId",
    path: _91orderId_93kdPeD7bI1AMeta?.path ?? "/partners/:partner()/user/history/:orderId()",
    meta: _91orderId_93kdPeD7bI1AMeta || {},
    alias: _91orderId_93kdPeD7bI1AMeta?.alias || [],
    redirect: _91orderId_93kdPeD7bI1AMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/user/history/[orderId].vue").then(m => m.default || m)
  },
  {
    name: indexWujfLO7iK2Meta?.name ?? "partners-partner-user-history",
    path: indexWujfLO7iK2Meta?.path ?? "/partners/:partner()/user/history",
    meta: indexWujfLO7iK2Meta || {},
    alias: indexWujfLO7iK2Meta?.alias || [],
    redirect: indexWujfLO7iK2Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/user/history/index.vue").then(m => m.default || m)
  },
  {
    name: indexeTkmJYEOVJMeta?.name ?? "partners-partner-user",
    path: indexeTkmJYEOVJMeta?.path ?? "/partners/:partner()/user",
    meta: indexeTkmJYEOVJMeta || {},
    alias: indexeTkmJYEOVJMeta?.alias || [],
    redirect: indexeTkmJYEOVJMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/user/index.vue").then(m => m.default || m)
  },
  {
    name: find_45user_45infoceT6Pt3vvOMeta?.name ?? "partners-partner-user-login-find-user-info",
    path: find_45user_45infoceT6Pt3vvOMeta?.path ?? "/partners/:partner()/user/login/find-user-info",
    meta: find_45user_45infoceT6Pt3vvOMeta || {},
    alias: find_45user_45infoceT6Pt3vvOMeta?.alias || [],
    redirect: find_45user_45infoceT6Pt3vvOMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/user/login/find-user-info.vue").then(m => m.default || m)
  },
  {
    name: index3NRpIvW4fJMeta?.name ?? "partners-partner-user-login",
    path: index3NRpIvW4fJMeta?.path ?? "/partners/:partner()/user/login",
    meta: index3NRpIvW4fJMeta || {},
    alias: index3NRpIvW4fJMeta?.alias || [],
    redirect: index3NRpIvW4fJMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/user/login/index.vue").then(m => m.default || m)
  },
  {
    name: simple_45signupiPxwYa2V1JMeta?.name ?? "partners-partner-user-login-simple-signup",
    path: simple_45signupiPxwYa2V1JMeta?.path ?? "/partners/:partner()/user/login/simple-signup",
    meta: simple_45signupiPxwYa2V1JMeta || {},
    alias: simple_45signupiPxwYa2V1JMeta?.alias || [],
    redirect: simple_45signupiPxwYa2V1JMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/user/login/simple-signup.vue").then(m => m.default || m)
  },
  {
    name: successvsKCHt4fehMeta?.name ?? "partners-partner-user-login-success",
    path: successvsKCHt4fehMeta?.path ?? "/partners/:partner()/user/login/success",
    meta: successvsKCHt4fehMeta || {},
    alias: successvsKCHt4fehMeta?.alias || [],
    redirect: successvsKCHt4fehMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/user/login/success.vue").then(m => m.default || m)
  },
  {
    name: usimsa_45signupdQYJOWbV6OMeta?.name ?? "partners-partner-user-login-usimsa-signup",
    path: usimsa_45signupdQYJOWbV6OMeta?.path ?? "/partners/:partner()/user/login/usimsa-signup",
    meta: usimsa_45signupdQYJOWbV6OMeta || {},
    alias: usimsa_45signupdQYJOWbV6OMeta?.alias || [],
    redirect: usimsa_45signupdQYJOWbV6OMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/user/login/usimsa-signup.vue").then(m => m.default || m)
  },
  {
    name: usimsaATeVXUmhHOMeta?.name ?? "partners-partner-user-login-usimsa",
    path: usimsaATeVXUmhHOMeta?.path ?? "/partners/:partner()/user/login/usimsa",
    meta: usimsaATeVXUmhHOMeta || {},
    alias: usimsaATeVXUmhHOMeta?.alias || [],
    redirect: usimsaATeVXUmhHOMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/user/login/usimsa.vue").then(m => m.default || m)
  },
  {
    name: indexIXOCSVFf6VMeta?.name ?? "partners-partner-user-mileage",
    path: indexIXOCSVFf6VMeta?.path ?? "/partners/:partner()/user/mileage",
    meta: indexIXOCSVFf6VMeta || {},
    alias: indexIXOCSVFf6VMeta?.alias || [],
    redirect: indexIXOCSVFf6VMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/user/mileage/index.vue").then(m => m.default || m)
  },
  {
    name: _91subOrderId_93CDLB1SEEoGMeta?.name ?? "partners-partner-user-refund-subOrderId",
    path: _91subOrderId_93CDLB1SEEoGMeta?.path ?? "/partners/:partner()/user/refund/:subOrderId()",
    meta: _91subOrderId_93CDLB1SEEoGMeta || {},
    alias: _91subOrderId_93CDLB1SEEoGMeta?.alias || [],
    redirect: _91subOrderId_93CDLB1SEEoGMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/user/refund/[subOrderId].vue").then(m => m.default || m)
  },
  {
    name: refund_45successvfxZIbaSxDMeta?.name ?? "partners-partner-user-refund-refund-success",
    path: refund_45successvfxZIbaSxDMeta?.path ?? "/partners/:partner()/user/refund/refund-success",
    meta: refund_45successvfxZIbaSxDMeta || {},
    alias: refund_45successvfxZIbaSxDMeta?.alias || [],
    redirect: refund_45successvfxZIbaSxDMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/user/refund/refund-success.vue").then(m => m.default || m)
  },
  {
    name: indexAD6B6UTeGoMeta?.name ?? "partners-partner-user-simple-signup",
    path: indexAD6B6UTeGoMeta?.path ?? "/partners/:partner()/user/simple-signup",
    meta: indexAD6B6UTeGoMeta || {},
    alias: indexAD6B6UTeGoMeta?.alias || [],
    redirect: indexAD6B6UTeGoMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/partners/[partner]/user/simple-signup/index.vue").then(m => m.default || m)
  },
  {
    name: moreDEXHDjEGXtMeta?.name ?? "product-more",
    path: moreDEXHDjEGXtMeta?.path ?? "/product/more",
    meta: moreDEXHDjEGXtMeta || {},
    alias: moreDEXHDjEGXtMeta?.alias || [],
    redirect: moreDEXHDjEGXtMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/product/more.vue").then(m => m.default || m)
  },
  {
    name: redirect_45to_45storevk9oDvjvNAMeta?.name ?? "redirect-to-store",
    path: redirect_45to_45storevk9oDvjvNAMeta?.path ?? "/redirect-to-store",
    meta: redirect_45to_45storevk9oDvjvNAMeta || {},
    alias: redirect_45to_45storevk9oDvjvNAMeta?.alias || [],
    redirect: redirect_45to_45storevk9oDvjvNAMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/redirect-to-store.vue").then(m => m.default || m)
  },
  {
    name: indexmyTA402mXcMeta?.name ?? "reviews",
    path: indexmyTA402mXcMeta?.path ?? "/reviews",
    meta: indexmyTA402mXcMeta || {},
    alias: indexmyTA402mXcMeta?.alias || [],
    redirect: indexmyTA402mXcMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: searchBIFC2dE21WMeta?.name ?? "search",
    path: searchBIFC2dE21WMeta?.path ?? "/search",
    meta: searchBIFC2dE21WMeta || {},
    alias: searchBIFC2dE21WMeta?.alias || [],
    redirect: searchBIFC2dE21WMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/search.vue").then(m => m.default || m)
  },
  {
    name: sentry_45example_45pageQDS8XtWeNGMeta?.name ?? "sentry-example-page",
    path: sentry_45example_45pageQDS8XtWeNGMeta?.path ?? "/sentry-example-page",
    meta: sentry_45example_45pageQDS8XtWeNGMeta || {},
    alias: sentry_45example_45pageQDS8XtWeNGMeta?.alias || [],
    redirect: sentry_45example_45pageQDS8XtWeNGMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/sentry-example-page.vue").then(m => m.default || m)
  },
  {
    name: app_45informationGLuFWzEXEYMeta?.name ?? "settings-app-information",
    path: app_45informationGLuFWzEXEYMeta?.path ?? "/settings/app-information",
    meta: app_45informationGLuFWzEXEYMeta || {},
    alias: app_45informationGLuFWzEXEYMeta?.alias || [],
    redirect: app_45informationGLuFWzEXEYMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/settings/app-information.vue").then(m => m.default || m)
  },
  {
    name: indexKIRFIU1ID4Meta?.name ?? "settings",
    path: indexKIRFIU1ID4Meta?.path ?? "/settings",
    meta: indexKIRFIU1ID4Meta || {},
    alias: indexKIRFIU1ID4Meta?.alias || [],
    redirect: indexKIRFIU1ID4Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/settings/index.vue").then(m => m.default || m)
  },
  {
    name: _91orderNo_93aqG0dZb0B7Meta?.name ?? "shuttle-purchase-orderNo",
    path: _91orderNo_93aqG0dZb0B7Meta?.path ?? "/shuttle/purchase/:orderNo()",
    meta: _91orderNo_93aqG0dZb0B7Meta || {},
    alias: _91orderNo_93aqG0dZb0B7Meta?.alias || [],
    redirect: _91orderNo_93aqG0dZb0B7Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/shuttle/purchase/[orderNo].vue").then(m => m.default || m)
  },
  {
    name: fail3T4HYp0EzeMeta?.name ?? "shuttle-purchase-callback-fail",
    path: fail3T4HYp0EzeMeta?.path ?? "/shuttle/purchase/callback/fail",
    meta: fail3T4HYp0EzeMeta || {},
    alias: fail3T4HYp0EzeMeta?.alias || [],
    redirect: fail3T4HYp0EzeMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/shuttle/purchase/callback/fail.vue").then(m => m.default || m)
  },
  {
    name: successf8eu6XJJbAMeta?.name ?? "shuttle-purchase-callback-success",
    path: successf8eu6XJJbAMeta?.path ?? "/shuttle/purchase/callback/success",
    meta: successf8eu6XJJbAMeta || {},
    alias: successf8eu6XJJbAMeta?.alias || [],
    redirect: successf8eu6XJJbAMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/shuttle/purchase/callback/success.vue").then(m => m.default || m)
  },
  {
    name: private_45policylPmxoUBHLxMeta?.name ?? "terms-private-policy",
    path: private_45policylPmxoUBHLxMeta?.path ?? "/terms/private-policy",
    meta: private_45policylPmxoUBHLxMeta || {},
    alias: private_45policylPmxoUBHLxMeta?.alias || [],
    redirect: private_45policylPmxoUBHLxMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/terms/private-policy.vue").then(m => m.default || m)
  },
  {
    name: usimsa_45termsy6BXW9Bz6aMeta?.name ?? "terms-usimsa-terms",
    path: usimsa_45termsy6BXW9Bz6aMeta?.path ?? "/terms/usimsa-terms",
    meta: usimsa_45termsy6BXW9Bz6aMeta || {},
    alias: usimsa_45termsy6BXW9Bz6aMeta?.alias || [],
    redirect: usimsa_45termsy6BXW9Bz6aMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/terms/usimsa-terms.vue").then(m => m.default || m)
  },
  {
    name: change_45passwordQPjQH4uwYNMeta?.name ?? "user-account-change-password",
    path: change_45passwordQPjQH4uwYNMeta?.path ?? "/user/account/change-password",
    meta: change_45passwordQPjQH4uwYNMeta || {},
    alias: change_45passwordQPjQH4uwYNMeta?.alias || [],
    redirect: change_45passwordQPjQH4uwYNMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/user/account/change-password.vue").then(m => m.default || m)
  },
  {
    name: delete_45successf5cQD1elzlMeta?.name ?? "user-account-delete-success",
    path: delete_45successf5cQD1elzlMeta?.path ?? "/user/account/delete-success",
    meta: delete_45successf5cQD1elzlMeta || {},
    alias: delete_45successf5cQD1elzlMeta?.alias || [],
    redirect: delete_45successf5cQD1elzlMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/user/account/delete-success.vue").then(m => m.default || m)
  },
  {
    name: deleteyJ9ZFzPBkdMeta?.name ?? "user-account-delete",
    path: deleteyJ9ZFzPBkdMeta?.path ?? "/user/account/delete",
    meta: deleteyJ9ZFzPBkdMeta || {},
    alias: deleteyJ9ZFzPBkdMeta?.alias || [],
    redirect: deleteyJ9ZFzPBkdMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/user/account/delete.vue").then(m => m.default || m)
  },
  {
    name: indexVBBUPJP8ffMeta?.name ?? "user-account",
    path: indexVBBUPJP8ffMeta?.path ?? "/user/account",
    meta: indexVBBUPJP8ffMeta || {},
    alias: indexVBBUPJP8ffMeta?.alias || [],
    redirect: indexVBBUPJP8ffMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/user/account/index.vue").then(m => m.default || m)
  },
  {
    name: consentKzqNDszYT4Meta?.name ?? "user-alarm-consent",
    path: consentKzqNDszYT4Meta?.path ?? "/user/alarm/consent",
    meta: consentKzqNDszYT4Meta || {},
    alias: consentKzqNDszYT4Meta?.alias || [],
    redirect: consentKzqNDszYT4Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/user/alarm/consent.vue").then(m => m.default || m)
  },
  {
    name: info_45benefitphrE84NjpuMeta?.name ?? "user-alarm-info-benefit",
    path: info_45benefitphrE84NjpuMeta?.path ?? "/user/alarm/info-benefit",
    meta: info_45benefitphrE84NjpuMeta || {},
    alias: info_45benefitphrE84NjpuMeta?.alias || [],
    redirect: info_45benefitphrE84NjpuMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/user/alarm/info-benefit.vue").then(m => m.default || m)
  },
  {
    name: kakao_45synclOvMwZh6cnMeta?.name ?? "user-callback-kakao-sync",
    path: kakao_45synclOvMwZh6cnMeta?.path ?? "/user/callback/kakao-sync",
    meta: kakao_45synclOvMwZh6cnMeta || {},
    alias: kakao_45synclOvMwZh6cnMeta?.alias || [],
    redirect: kakao_45synclOvMwZh6cnMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/user/callback/kakao-sync.vue").then(m => m.default || m)
  },
  {
    name: naverH941eAa88kMeta?.name ?? "user-callback-naver",
    path: naverH941eAa88kMeta?.path ?? "/user/callback/naver",
    meta: naverH941eAa88kMeta || {},
    alias: naverH941eAa88kMeta?.alias || [],
    redirect: naverH941eAa88kMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/user/callback/naver.vue").then(m => m.default || m)
  },
  {
    name: indextAmtLGY41jMeta?.name ?? "user-callback-supabase",
    path: indextAmtLGY41jMeta?.path ?? "/user/callback/supabase",
    meta: indextAmtLGY41jMeta || {},
    alias: indextAmtLGY41jMeta?.alias || [],
    redirect: indextAmtLGY41jMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/user/callback/supabase/index.vue").then(m => m.default || m)
  },
  {
    name: index9V7dRRx2VQMeta?.name ?? "user-coupons",
    path: index9V7dRRx2VQMeta?.path ?? "/user/coupons",
    meta: index9V7dRRx2VQMeta || {},
    alias: index9V7dRRx2VQMeta?.alias || [],
    redirect: index9V7dRRx2VQMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/user/coupons/index.vue").then(m => m.default || m)
  },
  {
    name: _91simHistoty_93GZQcHYGF27Meta?.name ?? "user-history-orderId-simHistoty",
    path: _91simHistoty_93GZQcHYGF27Meta?.path ?? "/user/history/:orderId()/:simHistoty()",
    meta: _91simHistoty_93GZQcHYGF27Meta || {},
    alias: _91simHistoty_93GZQcHYGF27Meta?.alias || [],
    redirect: _91simHistoty_93GZQcHYGF27Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/user/history/[orderId]/[simHistoty].vue").then(m => m.default || m)
  },
  {
    name: indexHq82ZarqOUMeta?.name ?? "user-history-orderId",
    path: indexHq82ZarqOUMeta?.path ?? "/user/history/:orderId()",
    meta: indexHq82ZarqOUMeta || {},
    alias: indexHq82ZarqOUMeta?.alias || [],
    redirect: indexHq82ZarqOUMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/user/history/[orderId]/index.vue").then(m => m.default || m)
  },
  {
    name: _91reservationId_93CBtqPpG9WkMeta?.name ?? "user-history-airport-taxi-reservationId",
    path: _91reservationId_93CBtqPpG9WkMeta?.path ?? "/user/history/airport-taxi/:reservationId()",
    meta: _91reservationId_93CBtqPpG9WkMeta || {},
    alias: _91reservationId_93CBtqPpG9WkMeta?.alias || [],
    redirect: _91reservationId_93CBtqPpG9WkMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/user/history/airport-taxi/[reservationId].vue").then(m => m.default || m)
  },
  {
    name: indexoAocH1WjjYMeta?.name ?? "user-history",
    path: indexoAocH1WjjYMeta?.path ?? "/user/history",
    meta: indexoAocH1WjjYMeta || {},
    alias: indexoAocH1WjjYMeta?.alias || [],
    redirect: indexoAocH1WjjYMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/user/history/index.vue").then(m => m.default || m)
  },
  {
    name: _91orderGroupId_93vyapEgczByMeta?.name ?? "user-history-insurance-orderGroupId",
    path: _91orderGroupId_93vyapEgczByMeta?.path ?? "/user/history/insurance/:orderGroupId()",
    meta: _91orderGroupId_93vyapEgczByMeta || {},
    alias: _91orderGroupId_93vyapEgczByMeta?.alias || [],
    redirect: _91orderGroupId_93vyapEgczByMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/user/history/insurance/[orderGroupId].vue").then(m => m.default || m)
  },
  {
    name: indexk3QLtbGbUrMeta?.name ?? "user",
    path: indexk3QLtbGbUrMeta?.path ?? "/user",
    meta: indexk3QLtbGbUrMeta || {},
    alias: indexk3QLtbGbUrMeta?.alias || [],
    redirect: indexk3QLtbGbUrMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/user/index.vue").then(m => m.default || m)
  },
  {
    name: find_45user_45infoaYhs5lmiPPMeta?.name ?? "user-login-find-user-info",
    path: find_45user_45infoaYhs5lmiPPMeta?.path ?? "/user/login/find-user-info",
    meta: find_45user_45infoaYhs5lmiPPMeta || {},
    alias: find_45user_45infoaYhs5lmiPPMeta?.alias || [],
    redirect: find_45user_45infoaYhs5lmiPPMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/user/login/find-user-info.vue").then(m => m.default || m)
  },
  {
    name: indexZWq46ELcfoMeta?.name ?? "user-login",
    path: indexZWq46ELcfoMeta?.path ?? "/user/login",
    meta: indexZWq46ELcfoMeta || {},
    alias: indexZWq46ELcfoMeta?.alias || [],
    redirect: indexZWq46ELcfoMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/user/login/index.vue").then(m => m.default || m)
  },
  {
    name: kakao_45simple_45signupt5z4y5sIwVMeta?.name ?? "user-login-kakao-simple-signup",
    path: kakao_45simple_45signupt5z4y5sIwVMeta?.path ?? "/user/login/kakao-simple-signup",
    meta: kakao_45simple_45signupt5z4y5sIwVMeta || {},
    alias: kakao_45simple_45signupt5z4y5sIwVMeta?.alias || [],
    redirect: kakao_45simple_45signupt5z4y5sIwVMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/user/login/kakao-simple-signup.vue").then(m => m.default || m)
  },
  {
    name: simple_45signuppVPLqIuKufMeta?.name ?? "user-login-simple-signup",
    path: simple_45signuppVPLqIuKufMeta?.path ?? "/user/login/simple-signup",
    meta: simple_45signuppVPLqIuKufMeta || {},
    alias: simple_45signuppVPLqIuKufMeta?.alias || [],
    redirect: simple_45signuppVPLqIuKufMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/user/login/simple-signup.vue").then(m => m.default || m)
  },
  {
    name: success7OC8zQ99kEMeta?.name ?? "user-login-success",
    path: success7OC8zQ99kEMeta?.path ?? "/user/login/success",
    meta: success7OC8zQ99kEMeta || {},
    alias: success7OC8zQ99kEMeta?.alias || [],
    redirect: success7OC8zQ99kEMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/user/login/success.vue").then(m => m.default || m)
  },
  {
    name: usimsa_45signupcEPUhVXDUQMeta?.name ?? "user-login-usimsa-signup",
    path: usimsa_45signupcEPUhVXDUQMeta?.path ?? "/user/login/usimsa-signup",
    meta: usimsa_45signupcEPUhVXDUQMeta || {},
    alias: usimsa_45signupcEPUhVXDUQMeta?.alias || [],
    redirect: usimsa_45signupcEPUhVXDUQMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/user/login/usimsa-signup.vue").then(m => m.default || m)
  },
  {
    name: usimsaY7PbX77kjsMeta?.name ?? "user-login-usimsa",
    path: usimsaY7PbX77kjsMeta?.path ?? "/user/login/usimsa",
    meta: usimsaY7PbX77kjsMeta || {},
    alias: usimsaY7PbX77kjsMeta?.alias || [],
    redirect: usimsaY7PbX77kjsMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/user/login/usimsa.vue").then(m => m.default || m)
  },
  {
    name: indexcXmhLidBEOMeta?.name ?? "user-mileage",
    path: indexcXmhLidBEOMeta?.path ?? "/user/mileage",
    meta: indexcXmhLidBEOMeta || {},
    alias: indexcXmhLidBEOMeta?.alias || [],
    redirect: indexcXmhLidBEOMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/user/mileage/index.vue").then(m => m.default || m)
  },
  {
    name: indexzppybscFOgMeta?.name ?? "user-point",
    path: indexzppybscFOgMeta?.path ?? "/user/point",
    meta: indexzppybscFOgMeta || {},
    alias: indexzppybscFOgMeta?.alias || [],
    redirect: indexzppybscFOgMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/user/point/index.vue").then(m => m.default || m)
  },
  {
    name: _91subOrderId_93lKFKpApAL4Meta?.name ?? "user-refund-subOrderId",
    path: _91subOrderId_93lKFKpApAL4Meta?.path ?? "/user/refund/:subOrderId()",
    meta: _91subOrderId_93lKFKpApAL4Meta || {},
    alias: _91subOrderId_93lKFKpApAL4Meta?.alias || [],
    redirect: _91subOrderId_93lKFKpApAL4Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/user/refund/[subOrderId].vue").then(m => m.default || m)
  },
  {
    name: _91reservationId_93PAl23cAdhuMeta?.name ?? "user-refund-airport-taxi-reservationId",
    path: _91reservationId_93PAl23cAdhuMeta?.path ?? "/user/refund/airport-taxi/:reservationId()",
    meta: _91reservationId_93PAl23cAdhuMeta || {},
    alias: _91reservationId_93PAl23cAdhuMeta?.alias || [],
    redirect: _91reservationId_93PAl23cAdhuMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/user/refund/airport-taxi/[reservationId].vue").then(m => m.default || m)
  },
  {
    name: _91orderGroupId_938LqsLmXlVtMeta?.name ?? "user-refund-insurance-orderGroupId",
    path: _91orderGroupId_938LqsLmXlVtMeta?.path ?? "/user/refund/insurance/:orderGroupId()",
    meta: _91orderGroupId_938LqsLmXlVtMeta || {},
    alias: _91orderGroupId_938LqsLmXlVtMeta?.alias || [],
    redirect: _91orderGroupId_938LqsLmXlVtMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/user/refund/insurance/[orderGroupId].vue").then(m => m.default || m)
  },
  {
    name: refund_45successu3KdOqZHhDMeta?.name ?? "user-refund-refund-success",
    path: refund_45successu3KdOqZHhDMeta?.path ?? "/user/refund/refund-success",
    meta: refund_45successu3KdOqZHhDMeta || {},
    alias: refund_45successu3KdOqZHhDMeta?.alias || [],
    redirect: refund_45successu3KdOqZHhDMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/user/refund/refund-success.vue").then(m => m.default || m)
  },
  {
    name: _91reviewId_93M9FsUnazazMeta?.name ?? "user-review-edit-reviewId",
    path: _91reviewId_93M9FsUnazazMeta?.path ?? "/user/review/edit/:reviewId()",
    meta: _91reviewId_93M9FsUnazazMeta || {},
    alias: _91reviewId_93M9FsUnazazMeta?.alias || [],
    redirect: _91reviewId_93M9FsUnazazMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/user/review/edit/[reviewId].vue").then(m => m.default || m)
  },
  {
    name: indexv0vbTSvlZUMeta?.name ?? "user-review",
    path: indexv0vbTSvlZUMeta?.path ?? "/user/review",
    meta: indexv0vbTSvlZUMeta || {},
    alias: indexv0vbTSvlZUMeta?.alias || [],
    redirect: indexv0vbTSvlZUMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/user/review/index.vue").then(m => m.default || m)
  },
  {
    name: successPWklmd2oAoMeta?.name ?? "user-review-success",
    path: successPWklmd2oAoMeta?.path ?? "/user/review/success",
    meta: successPWklmd2oAoMeta || {},
    alias: successPWklmd2oAoMeta?.alias || [],
    redirect: successPWklmd2oAoMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/user/review/success.vue").then(m => m.default || m)
  },
  {
    name: _91reviewId_93X2M1bwIkwnMeta?.name ?? "user-review-write-reviewId",
    path: _91reviewId_93X2M1bwIkwnMeta?.path ?? "/user/review/write/:reviewId()",
    meta: _91reviewId_93X2M1bwIkwnMeta || {},
    alias: _91reviewId_93X2M1bwIkwnMeta?.alias || [],
    redirect: _91reviewId_93X2M1bwIkwnMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/user/review/write/[reviewId].vue").then(m => m.default || m)
  },
  {
    name: verify_45noticew6e2RMf9tdMeta?.name ?? "verify-notice",
    path: verify_45noticew6e2RMf9tdMeta?.path ?? "/verify-notice",
    meta: verify_45noticew6e2RMf9tdMeta || {},
    alias: verify_45noticew6e2RMf9tdMeta?.alias || [],
    redirect: verify_45noticew6e2RMf9tdMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/verify-notice.vue").then(m => m.default || m)
  },
  {
    name: indexL6n4ehuQzmMeta?.name ?? "voucher-orderId",
    path: indexL6n4ehuQzmMeta?.path ?? "/voucher/:orderId()",
    meta: indexL6n4ehuQzmMeta || {},
    alias: indexL6n4ehuQzmMeta?.alias || [],
    redirect: indexL6n4ehuQzmMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/voucher/[orderId]/index.vue").then(m => m.default || m)
  }
]